export default __webpack_public_path__ + "static/media/gummycandies.f5e43bfa.jpg";